<template>
  <div class='filter' v-click-outside='closeDropdown'>
    <form class='default-filters'>
      <div v-for='filter in filterList' :key='filter' class='btn-group dropdown form-group' role='group' aria-expanded='false' ref='dropdown'>
        <button aria-expanded='false' aria-haspopup='true' data-toggle='dropdown'>
          {{ $t('root.filters.' + filter) }}
          <i class='fas fa-sort-down' aria-hidden='true'></i>
        </button>

        <div class='dropdown-menu'>
          <component :is="'filter-items-by-' + filter" @cancel='closeDropdown' />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import _filter_items_by_document from './_filter_by_document_id'
import _filter_items_by_product from './_filter_by_product_id'
import _filter_items_by_record_id_not_null from './_filter_by_items_with_record'
import _filter_items_by_shared from './_filter_by_shared'
import _filter_items_by_exp_status from './_filter_by_exp_status'

export default {
  components: {
    'filter-items-by-document': _filter_items_by_document,
    'filter-items-by-product': _filter_items_by_product,
    'filter-items-by-record-id-not-null': _filter_items_by_record_id_not_null,
    'filter-items-by-shared-eq': _filter_items_by_shared,
    'filter-items-by-status-in': _filter_items_by_exp_status,
  },
  mounted() {
    $(this.$refs.dropdown).on('hide.bs.dropdown', () => {
      if (!this.isClosable)
        return false

      this.isClosable = false
      return true
    })
  },
  data() {
    return {
      isClosable: false,
    }
  },
  computed: {
    filterList() {
      return Object.freeze(['product', 'document', 'record-id-not-null', 'shared-eq', 'status-in'])
    },
  },
  methods: {
    closeDropdown() {
      this.isClosable = true
    },
  },
}
</script>

<style lang='sass' scoped>
.filter
  display: flex
  margin-top: 10px
  .default-filters
    .dropdown
      > button
        background: none
        border: none
  .form-group
    margin-bottom: 0
    margin-right: 15px
  .dropdown-menu
    li
      color: #686868
      font-weight: 500
      padding-bottom: 5px
      a
        color: #686868
        font-weight: 500
    select
      border: 1px solid #ccc
      border-radius: 3px
      color: #686868
      font-weight: 500
      width: 100%
    label
      margin-bottom: 0
      padding: 5px 0 0
</style>
